import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class EcommerceandOnlineShops extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="Ecommerce and Online Shops"
					title={"ecommerce and online shops"}
					image={require('./image-2.jpg')}
				/>
				<div className="entry-content page-blog">

				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                               			 Ecommerce and Online Shops
                            			</div>
                       			 </h2>
                    		</div>

					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							
								
								<p>More and more people are turning to online shopping over the traditional retail experience. If your business sells physical goods, digital downloads or fixed price services, chances are you will benefit from an ecommerce site.</p>

								<h4>What are the advantages of ecommerce? </h4>


								<p>Online shopping is easier for the user - testimonials, product reviews, descriptions, prices and delivery are all available in one location. Ecommerce platforms also make customer retention, audience analysis and future marketing much easier for your business, with valuable customer databases categorised into easy to market lists (such as cart abandoners). 
</p>
<p>Our Wordpress based ecommerce platforms are easy to use, simple to update, and provide smooth paths for your user to follow to checkout. If you require more complex ecommerce systems, other platforms such as Megento or Prestashop are available. </p>
<p>Our website development services are perfect for a range of business sizes, with options available to suit most budgets. We also provide extremely secure hosting services to our clients to ensure maximum safety and security for your online investment.
</p>
<a href="https://www.moshi.com.au/what-weve-done/lpc"><img src={require('./LPC.png')} style={{padding: 30}} height="375" width="350" alt="Liquid Protective Coatings Website" className="align-centre" align="centre" /></a>

<a href="https://www.moshi.com.au/what-weve-done/picton-trailer-hire"><img src={require('./Picton2.png')} style={{padding: 30}} height="375" width="350" alt="Picton Trailer Hire" className="align-centre" align="centre" /></a>

<a href="https://www.moshi.com.au/what-weve-done/hearth-house"><img src={require('./Hearth House.png')} style={{padding: 30}}  height="375" width="350" alt="Hearth House Bunbury" className="align-centre" align="centre" /></a>
<br></br>
<hr></hr>
<h2>Related Services:</h2>
				<a class="btn" href="https://www.moshi.com.au/whatwedo/website-development">Website Development</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-hosting">Website Hosting</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/google-advertising">Google Advertising</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/domain-address-registration">Domain Address Registration</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-and-newsletter-writing">Website and Newsletter Writing</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/graphic-design">Graphic Design</a>
					
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>
<hr></hr>
<br></br>
<h3> If you don’t have a website yet, or your existing site isn’t converting your online traffic, come in for a zero obligation chat.</h3>
					</div>
				</div>

			</div>
		);
	}
}

export default EcommerceandOnlineShops;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/EcommerceandOnlineShops.js